export default __webpack_public_path__ + "static/instance03-98fac0230cf17edb2d1cc9a8518623da.png";